import { render, staticRenderFns } from "./TransactionReceipt.vue?vue&type=template&id=f17d28da&scoped=true&"
import script from "./TransactionReceipt.vue?vue&type=script&lang=js&"
export * from "./TransactionReceipt.vue?vue&type=script&lang=js&"
import style0 from "./TransactionReceipt.vue?vue&type=style&index=0&id=f17d28da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17d28da",
  null
  
)

export default component.exports